var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDownS48Filled = function SvgIconDownS48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.31 17.26c-.52-.9-1.48-1.46-2.52-1.46h-13.6c-1.04 0-2 .56-2.52 1.46-.52.9-.51 2.01.01 2.91l6.8 11.6c.53.9 1.46 1.43 2.5 1.43s1.98-.54 2.5-1.43l6.8-11.6c.52-.89.53-2.01.01-2.91h.02Z",
    fill: "current"
  })));
};
export default SvgIconDownS48Filled;